import {IHttpInterceptor, IHttpResponse, IPromise, IQService, IRootScopeService} from 'angular';
import {TSAuthEvent} from '../../models/enums/TSAuthEvent';
import HttpBuffer from './HttpBuffer';

export default class HttpAuthInterceptor implements IHttpInterceptor {

    static $inject = ['$rootScope', '$q', 'CONSTANTS', 'httpBuffer'];
    /* @ngInject */
    constructor(private $rootScope: IRootScopeService, private $q: IQService, private CONSTANTS: any,
                private httpBuffer: HttpBuffer) {
    }

    public responseError = <T>(rejection: any): IPromise<IHttpResponse<T>> | IHttpResponse<T> => {
        switch (rejection.status) {
            case 401:
                // exclude requests from the login form
                if (rejection.config && rejection.config.url === this.CONSTANTS.REST_API + 'auth/login') {
                    return this.$q.reject(rejection);
                }
                // all requests that failed due to notAuthenticated are appended to httpBuffer. Use httpBuffer.retryAll to submit them.
                let deferred = this.$q.defer();
                this.httpBuffer.append(rejection.config, deferred);
                this.$rootScope.$broadcast(TSAuthEvent[TSAuthEvent.NOT_AUTHENTICATED], rejection);
                return deferred.promise as IPromise<IHttpResponse<T>>;
            case 403:
                this.$rootScope.$broadcast(TSAuthEvent[TSAuthEvent.NOT_AUTHORISED], rejection);
                return this.$q.reject(rejection);
        }
        return this.$q.reject(rejection);
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/service/HttpAuthInterceptor.ts